export const balanceBonus = {
  balanceBonus_title: "Bonus",
  balanceBonus_statusActive: "Aktief",
  balanceBonus_statusUnlocked: "Ontsluit",
  balanceBonus_explain: "Speelbaar op slots en lotery slegs. Nie onttrekbaar nie.",
  balanceBonus_progressLabel: "Weddenskapvordering",
  balanceBonus_wageringRemaining: "Wed {{amount}} meer om jou winste te ontsluit",
  balanceBonus_wageringMet: "Winste ontsluit!",
  balanceBonus_expires: "Verval op {{date}}",
};

export default balanceBonus;
